export const LIFE_INSURANCE_STEPS = {
    START: 'step-1-1',
    PACKAGE_AND_COVERAGES: {
        MAIN_REASON: 'step-2-1',
        AGE: 'step-2-2',
        INCOME: 'step-2-3',
        CHOOSE_PACKAGE: 'step-2-4',
        CUSTOM_COVERS: 'step-2-5',
        DURATION: 'step-2-6',
        PAYMENT_SCHEDULE: 'step-2-7',
    },
    PACKAGES_DONE: 'step-3-1',
    LIFESTYLE_AND_HEALTH: {
        PROFESSION: 'step-4-1',
        HAS_HOBBIES: 'step-4-2',
        HOBBIES_DETAIL: 'step-4-3',
        TRANSPORTATION: 'step-4-4',
        HALFWAY_LOGIN: 'step-4-5',
        CONTACT_DETAILS: 'step-4-6',
        HEALTH_QUESTIONS: 'step-4-7',
        HEALTH_QUESTIONS_SUMMARY: 'step-4-8',
    },
    LIFESTYLE_AND_HEALTH_DONE: 'step-5-1',
    SUMMARY: 'step-6-1',
    SIGNING_THE_CONTRACT: {
        TAX_INFORMATION: 'step-7-1',
        TAX_INFORMATION_SUMMARY: 'step-7-2',
        BENEFICIARIES: 'step-7-3',
        INVOICE_INFORMATION: 'step-7-4',
        OVERVIEW_OF_CONTRACT: 'step-7-5',
        CONSENTS: 'step-7-6',
    },
    PAYMENT: 'step-8-1',
};
